// import { createApp } from 'vue'
// import App from './App.vue'
// import router from './router'
// import store from './store'
// import { MotionPlugin } from '@vueuse/motion'
// import './assets/index.css'

// createApp(App).use(store).use(router).mount('#app')

import { createApp } from 'vue'
import { MotionPlugin } from '@vueuse/motion'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/index.css'

const app = createApp(App)
app.use(store)
app.use(router)
app.use(MotionPlugin)
app.mount('#app')
